export const pointExpirationScheduleTableMessages = {
  expirationDate: 'Expiration Date',
  points: 'Points',
};
